import CaseStudiesPage from './CaseStudiesPage';

export default CaseStudiesPage;



// WEBPACK FOOTER //
// ./src/components/CaseStudiesPage/index.js